export default {
  isJson: (rule, value, callback) => {
    try {
      JSON.parse(value);
      callback();
    } catch (error) {
      callback(new Error('Formato non valido'));
    }
  },
};
